(() => {
    function toggleBannerVisible(isVisible) {
        var container = document.querySelector("#AbraCartDrawerBannerContainer .abra-banner-content");
        if (container) {
            container.style.display = isVisible ? 'block' : 'none';
        }
    }
    
    function resetAbraState() {
        toggleBannerVisible(true);
        window.abraChangingCart = false;
    }
    
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        const url = args[0]?.toString() || '';
        
        if (url.includes('_abraignore=1') && ((url.includes('/cart/change.js') || url.includes('/cart/add.js')))) {
            window.abraChangingCart = true;
            toggleBannerVisible(false);
        }
        
        return originalFetch.apply(this, args);
    };

    window.addEventListener("abra:cart:changed", function() {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        setTimeout(resetAbraState, 500);
    });

    document.addEventListener("cart:refresh", function() {
        if (window.abraChangingCart) {
            setTimeout(resetAbraState, 500);
        }
    });

    document.addEventListener("DOMContentLoaded", function() {
        var cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
            cartDrawer.addEventListener("dialog:after-show", function() {
                setTimeout(function() {
                    window.dispatchEvent(new CustomEvent("abra:cart:changed"));
                }, 200);
            });
        }
    });
})();